import React from 'react'
import Resx from '@/components/Resx'
import { Form, Input, Label, FormGroup } from 'reactstrap'
import ReportTemplateSelector from '@/components/reporting/reportTemplateSelector'
import { Validator } from '@/components/validation'
import { DropDownList } from '@/components/dropDownList'
import { withPermissions } from '@/decorators/withPermissions'
import { EnumDropDownList } from '@/components/enumDropDownList'
import { reportGroupStatus } from '@/enums/reportGroupStatus'
import context from '@/context'
import { formatDate, defaultDateTimeFormat } from '@/utils/dateUtilities'
import { DatePicker } from '@/components/DatePicker'

@withPermissions()
class ReportingGroupDetailFormContent extends React.Component {
  render () {
    const canManage = this.props.isGranted('CanManageReportGroups')
    return (
      <Form>
        <FormGroup>
          <Label><Resx name='Common.Name' /></Label>
          <Validator name='name' value={this.props.name} required>
            <Input disabled={!canManage} value={this.props.name} onChange={e => this.props.onChange({ name: e.target.value })} />
          </Validator>
        </FormGroup>
        <FormGroup>
          <Label><Resx name='Reporting.ReportingCycle' /></Label>
          <div>
            <Validator name='reportingCycle' value={this.props.reportingCycle} required>
              <DropDownList dataSource={context.api.reportingCyclesService.getLookup}
                disabled={!canManage}
                value={this.props.reportingCycle}
                onChange={({ item }) => this.props.onChange({ reportingCycle: item })}
              />
            </Validator>
          </div>
        </FormGroup>
        {this.props.showState && <FormGroup>
          <Label><Resx name='Reporting.State' /></Label>
          <div>
            <EnumDropDownList
              value={this.props.state}
              onChange={e => this.props.onChange({ state: e.value })}
              enumDefinition={reportGroupStatus} />
            <Resx name='Reporting.LastStateChange' /> {formatDate(this.props.stateChangeDate, defaultDateTimeFormat) || '-'}
          </div>
        </FormGroup>}
        <FormGroup>
          <div>
            <ReportTemplateSelector
              disabled={!canManage}
              selectedTemplates={this.props.templates}
              onChange={templates => this.props.onChange({ templates })}
            />
          </div>
        </FormGroup>
        <FormGroup>
          <Label><Resx name='Reporting.SubmissionWorkflow' /></Label>
          <DropDownList
            dataSource={req => context.api.workflowDefinitionService.getReportWorkflows(1 | 4, req)}
            value={this.props.submissionWorkflow}
            textField={this.props.localizeProps()}
            valueField='id'
            disabled={!canManage}
            onChange={({ item }) => this.props.onChange({ submissionWorkflow: item })} />
        </FormGroup>
        <FormGroup>
          <Label><Resx name='Reporting.ImposeFineWorkflow' /></Label>
          <DropDownList
            value={this.props.imposeFineWorkflow}
            dataSource={req => context.api.workflowDefinitionService.getReportWorkflows('FineImposition', req)}
            textField={this.props.localizeProps()}
            valueField='id'
            disabled={!canManage}
            onChange={({ item }) => this.props.onChange({ imposeFineWorkflow: item })} />
        </FormGroup>
        <FormGroup>
          <Label><Resx name='Reporting.LastRun' /></Label>
          <DatePicker
            value={this.props.lastRun}
            onChange={lastRun => this.props.onChange({ lastRun })} />
        </FormGroup>
        {this.props.children}
      </Form>
    )
  }
}

export default ReportingGroupDetailFormContent



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportingGroups/reportingGroupDetailFormContent.js